var misc_codeBind = { parent: '=', codepack: '=' };
var MiscCodesEditController = (function () {
    function MiscCodesEditController(env, $scope) {
        this.env = env;
        this.$scope = $scope;
    }
    MiscCodesEditController.$inject = ['env', '$scope'];
    return MiscCodesEditController;
}());
var MiscCodesEditComponent = (function () {
    function MiscCodesEditComponent() {
        this.bindings = misc_codeBind; //Bindings to connect with parent
        this.templateUrl = 'codes.html';
        this.controller = MiscCodesEditController;
    }
    return MiscCodesEditComponent;
}());
angular
    .module('application')
    .component('editMiscCodesSection', new MiscCodesEditComponent());

//# sourceMappingURL=codes.edit.component.js.map
